import _ from "lodash";
import * as Yup from "yup";
import { STUDENT } from "../../../consts/methods.consts";
import { useFormik } from "formik";
import ChakraModal from "../../common/chakra-modal/ChakraModal";
import { FormInput } from "../../common/form-controllers/FormInput";
import { ToastService } from "../../../services/toast.service";
import { FormDropdown } from "../../common/form-controllers/FormDropdown";
import { FormTextArea } from "../../common/form-controllers/FormTextArea";
import { DROPDOWN_TAGS, STUDENT_TAG } from "../../../consts/tags.consts";
import { useGetQuery, usePostMutation } from "../../../services/api.service";
import { NavigateFunction, useNavigate } from "react-router-dom";
import PageHeader, { PageHeaderActions } from "../../common/page-header/PageHeader";
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable";
import { SectionCard, SectionCardCreatable } from "../../common/section-card/SectionCard";
import { SimpleGrid, useDisclosure, useToast } from "@chakra-ui/react";
import { customeJsonParser } from "../../../utils/utils";
import FormSelect from "../../common/form-controllers/FormSelect";
import { useRef } from "react";

const NewStudentPage = () => {

    const disclosure = useDisclosure()
    const navigate: NavigateFunction = useNavigate();
    const selectRef = useRef(false)
    const indexRef: any = useRef<number>()
    const workExperienceDisclosure = useDisclosure()
    const toast = new ToastService(useToast());
    const [create] = usePostMutation();

    const formik = useFormik({
        initialValues: {},
        validationSchema: Yup.object({
            nic: Yup.string().matches(/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/, 'Enter valid NIC number').required('NIC is required'),
            full_name:Yup.string().required('Full name is required'),
            whatsapp_number: Yup.string().matches(/^[0-9]{10}$/, 'Enter valid Whatsapp mobile number').nullable(),
            place_of_work_official_number: Yup.string().matches(/^[0-9]{10}$/, 'Enter valid mobile number').nullable(),
            mobile_number: Yup.string().matches(/^[0-9]{10}$/, 'Enter valid mobile number').nullable(),
            email:Yup.string().email('Enter valid email address').required('Email is required')
        }),
        onSubmit: async (values: any) => {
            try {
                const res = await create({
                    method: STUDENT.ADD,
                    body: values,
                    invalidatesTags: [STUDENT_TAG.VIEW, STUDENT_TAG.LIST, DROPDOWN_TAGS.LIST]
                }).unwrap();

                const newId = _.get(res, 'message')

                if (!newId) {
                    throw new Error("Student creation failed.")
                }

                toast.setTitle("Success").setDescription("Student has been created successfully.").showSuccessToast();

                setTimeout(() => {
                    navigate(`/app/student/${newId}`);
                }, 1500)

            } catch (error: any) {
                let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
                if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
            }
        }
    })


    const { data: initialData } = useGetQuery({
        method: STUDENT.INIT,
        providesTags: [STUDENT_TAG.LIST, DROPDOWN_TAGS.LIST]
    })

    const dropDownData = _.get(initialData, 'message')


    const actions: PageHeaderActions = [
        {
            text: "Save",
            onClick: formik.submitForm,
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]

    const creatable: SectionCardCreatable = {
        text: "Add New",
        onClick: () => {
            disclosure.onOpen();
        }
    }

    const workExperienceCreatable: SectionCardCreatable = {
        text: "Add New",
        onClick: () => {
            workExperienceDisclosure.onOpen();
        }
    }


    const EDUCATION_TABLE_COLUMNS: ChakraTableColumns = [
        {
            header: "Level",
            accessor: "level",
        },
        {
            header: "Title",
            accessor: "title",
        },
        {
            header: "Obtained Year",
            accessor: "obtained_year",
        },
        {
            header: "Action",
            accessor: "",
            width: 100,
            options: [
                {
                    label: "Delete",
                    onClick(item: any) {
                        const newItems = _.get(formik.values, 'educational_qualifications', []).filter((i: any) => (
                            i !== item
                        ))
                        formik.setFieldValue('educational_qualifications', newItems)
                    },
                }
            ]
        },
    ]

    const WORK_EXPERIENCE_TABLE_COLUMNS: ChakraTableColumns = [
        {
            header: "Designation",
            accessor: "designation",
        },
        {
            header: "Work Place",
            accessor: "work_place",
        },
        {
            header: "from",
            accessor: "from",
        },
        {
            header: "To",
            accessor: "to",
        },
        {
            header: "Action",
            accessor: "",
            width: 100,
            options: [
                {
                    label: "Delete",
                    onClick(item: any) {
                        const newItems = _.get(formik.values, 'student_work_experience', []).filter((i: any) => (
                            i !== item
                        ))
                        formik.setFieldValue('student_work_experience', newItems)
                    },
                },
                {
                    label: "Edit",
                    confirmation: false,
                    onClick(item: any) {
                        selectRef.current = true
                        indexRef.current = _.get(formik.values, 'student_work_experience', []).findIndex(
                            (line: any) =>
                                (line.designation === item.designation && line.work_place === item.work_place && line.from === item.from && line.to === item.to)
                        )
                        workExperienceChildFormik.setValues({ ...item })
                        workExperienceDisclosure.onOpen()
                    },
                }
            ]
        },
    ]

    const childFormik = useFormik({
        initialValues: {},
        validationSchema: Yup.object({
            level: Yup.string().required("Level is required"),
            title: Yup.string().required("title is required"),
            obtained_year: Yup.string().required("Obtained Year is required"),
        }),
        onSubmit: async (values: any) => {

            disclosure.onClose()
            formik.setFieldValue('educational_qualifications', [
                ..._.get(formik.values, 'educational_qualifications', []), values
            ])

            childFormik.resetForm()
        }
    })

    const workExperienceChildFormik = useFormik({
        initialValues: {},
        validationSchema: Yup.object({
            designation: Yup.string().required("Designation is required"),
            work_place: Yup.string().required("Work Place is required"),
            from: Yup.string().required("From Year is required"),
            to: Yup.string().required("to Year is required"),
        }),
        onSubmit: async (values: any) => {

            const alreadyExsist = _.get(formik.values, 'student_work_experience', []).filter((item: any) => (
                values.from === item.from &&
                values.to === item.to &&
                values.designation === item.designation &&
                values.work_place === item.work_place
            ))

            if (_.size(alreadyExsist) > 0) {
                toast.setDescription('This is already exists').setStatus('warning').setTitle('Warning').show()
                return
            }
            if (selectRef.current) {
                const ModuleContent: any = [..._.get(formik.values, 'student_work_experience', [])]
                ModuleContent[indexRef.current] = { ...values }
                formik.setFieldValue('student_work_experience', ModuleContent)
                workExperienceDisclosure.onClose()
                workExperienceChildFormik.resetForm()
                selectRef.current = false
                return
            }

            formik.setFieldValue('student_work_experience', [
                ..._.get(formik.values, 'student_work_experience', []), values
            ])

            workExperienceDisclosure.onClose()
            workExperienceChildFormik.resetForm()
        }
    })

    const onCloseworkExperienceModal = () => {
        selectRef.current = false
        workExperienceChildFormik.resetForm()
        workExperienceDisclosure.onClose()
    }


    return (
        <div>
            <PageHeader enableBackButton actions={actions} title={"Create New Student"}
                subtitle={'Student'} />
            <SectionCard backgroundColor=" bg-white" title="Basic Information" p={3}>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 4, xl: 4 }} spacing={3}>
                    <FormInput isRequired label="NIC" formik={formik} name="nic" />
                    {/* <FormDropdown options={_.get(dropDownData, 'users')} formik={formik}
                        name={'user'}
                        autoFocus
                        label={'User'} /> */}
                    <FormInput label="First Name" formik={formik} name="first_name" />
                    <FormInput label="Last Name" formik={formik} name="last_name" />
                    <FormInput isRequired label="Full Name" formik={formik} name="full_name" />
                    <FormInput label="Name with Initials" formik={formik} name="name_with_initials" />
                    <FormInput type="date" label="Date of Birth" formik={formik} name="date_of_birth" />
                    <FormDropdown isRequired options={gender} formik={formik}
                        name={'gender'}
                        autoFocus
                        label={'Gender'} />


                    <FormDropdown isRequired options={salutation} formik={formik}
                        name={'salutation'}
                        autoFocus
                        label={'Salutation'} />
                    <FormInput type="date" label="From" formik={formik} name="from" />
                    <FormInput type="date" label="To" formik={formik} name="to" />
                    <FormInput label="Place of Work" formik={formik} name="place_of_work" />
                    <FormInput label="Present Designation" formik={formik} name="present_post" />
                    <FormSelect method={STUDENT.GET_SERVICES}
                        label="Service" formik={formik}
                        name="service" />

                </SimpleGrid>
            </SectionCard>
            <SectionCard backgroundColor="bg-white" title="Contact Information" p={3}>
                <SimpleGrid columns={{ base: 1, md: 2, lg: 4, xl: 4 }} spacing={3}>
                    <FormInput label="Mobile Number" formik={formik} name="mobile_number" />
                    <FormInput isRequired label="Email" formik={formik} name="email" />
                    <FormTextArea label="Personal Address" formik={formik} name="personal_address" />
                    <FormTextArea label="Office Address" formik={formik} name="office_address" />
                </SimpleGrid>
            </SectionCard>
            <SectionCard creatable={creatable} title="Educational Qualification" p={3}>
                <ChakraTable size={"sm"}
                    columns={EDUCATION_TABLE_COLUMNS}
                    data={_.get(formik.values, 'educational_qualifications', [])} />
                <ChakraModal primaryAction={childFormik.submitForm} primaryButtonText={"Add"}
                    modalTitle={'Add new module'} {...disclosure}>
                    <SimpleGrid columns={{ base: 1, md: 1, lg: 1, xl: 1 }} spacing={3}>
                        <FormDropdown isRequired options={levels} formik={childFormik}
                            name={'level'}
                            autoFocus
                            label={'Level'} />
                        <FormInput isRequired label="Title" formik={childFormik} name="title" />
                        <FormInput type="date" isRequired label="Obtained Year" formik={childFormik} name="obtained_year" />
                    </SimpleGrid>
                </ChakraModal>
            </SectionCard>

            <SectionCard creatable={workExperienceCreatable} title="Work Experience" p={3}>
                <ChakraTable size={"sm"}
                    columns={WORK_EXPERIENCE_TABLE_COLUMNS}
                    data={_.get(formik.values, 'student_work_experience', [])} />
                <ChakraModal primaryAction={workExperienceChildFormik.submitForm} primaryButtonText={"Add"}
                    modalTitle={selectRef.current ? 'Edit work Experience' : 'Add new Work Experience'} {...workExperienceDisclosure} onClose={onCloseworkExperienceModal}>
                    <SimpleGrid columns={{ base: 1, md: 1, lg: 1, xl: 1 }} spacing={3}>
                        <FormInput isRequired label="Designation" formik={workExperienceChildFormik} name="designation" />
                        <FormInput isRequired label="Work Place" formik={workExperienceChildFormik} name="work_place" />
                        <FormInput type="date" isRequired label="From" formik={workExperienceChildFormik} name="from" />
                        <FormInput type="date" isRequired label="To" formik={workExperienceChildFormik} name="to" />
                    </SimpleGrid>
                </ChakraModal>
            </SectionCard>

        </div>
    )
}

export default NewStudentPage


const gender = [{ value: "Male", label: "Male" }, { value: "Female", label: "Female" }]

const salutation = [
    { value: "Mr", label: "Mr" },
    { value: "Ms", label: "Ms" },
    { value: "Rev", label: "Rev" },
    { value: "Dr", label: "Dr" },
    { value: "Prof", label: "Prof" },
    { value: "Eng", label: "Eng" },
    { value: "Comm", label: "Comm" }
]

const levels = [
    { value: "A/L", label: "A/L" },
    { value: "Diploma", label: "Diploma" },
    { value: "Bachelor's Degree", label: "Bachelor's Degree" },
    { value: "Master's Degree", label: "Master's Degree" },
    { value: "Doctoral Degree", label: "Doctoral Degree" },
]
